import { PeriodTypeValue } from 'src/pages/reporting/auctions/components/period-type';

export const auctionTitles: { [key in PeriodTypeValue]: string } = {
  WITHINDAY: 'Within-Day Auctions',
  DAY: 'Day Ahead Auctions',
  MONTH: 'Monthly Auctions',
  QUARTER: 'Quarterly Auctions',
  YEAR: 'Yearly Auctions',
};
